<template>
  <div>
    <el-dialog :title="this.value.isCreate ? '添加跑马灯任务' : '修改跑马灯任务'" center :visible.sync="visible" @closed="onClosed"
      :close-on-click-modal="false" :close-on-press-escape="false" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" size="mini" style="width:700px">
        <el-form-item label="文本" prop="text">
          <el-input v-model="form.text" clearable></el-input>
        </el-form-item>
        <el-form-item label="优先级" prop="priority">
          <el-input v-model="form.priority" placeholder="值越大优先级越高" clearable></el-input>
        </el-form-item>
        <el-form-item label="循环播报时间" prop="repeatSpec">
          <el-input v-model="form.repeatSpec" placeholder="比如“从第1分钟开始每隔3分钟播报一次”：1-59/3 * * * *" clearable style="width: 350px"></el-input>
          <span style="margin-left: 5px;">（遵循<a href="https://crontab.guru" target="_blank" style="color: blue">[标准Cron格式]</a>）</span>
        </el-form-item>
        <el-form-item label="有效期起始时间">
          <el-date-picker v-model="form.validateFromWhen" type="datetime" :clearable="false" placeholder="选择时间"
            format="yyyy-MM-dd HH:mm" value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="有效期结束时间">
          <el-date-picker v-model="form.validateToWhen" type="datetime" :clearable="false" placeholder="选择时间"
            format="yyyy-MM-dd HH:mm" value-format="timestamp">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const luxon = require("luxon");

export default {
  data() {
    return {
      visible: true,
      form: {
        id: "",
        text: "",
        priority: 0,
        repeatSpec: "",
        validateFromWhen: luxon.DateTime.now().startOf("day").toMillis(),
        validateToWhen: luxon.DateTime.now().startOf("day").toMillis(),
      },
      rules: {
        text: [{ required: true, message: " ", trigger: "blur" }],
        priority: [{ required: true, message: " ", trigger: "blur" }],
        repeatSpec: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.id = this.value.oldData.id;
      this.form.text = this.value.oldData.text;
      this.form.priority = this.value.oldData.priority;
      this.form.repeatSpec = this.value.oldData.repeatSpec;
      this.form.validateFromWhen = this.value.oldData.validateFromWhen;
      this.form.validateToWhen = this.value.oldData.validateToWhen;
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.addMarquee();
      } else {
        this.updateMarquee();
      }
    },

    /**
     * 新增跑马灯任务
     */
    addMarquee() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let priority = parseInt(this.form.priority);
        if (priority.toString() != this.form.priority || priority < 0) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addMarqueeSchedule`,
            {
              entry: {
                text: this.form.text,
                priority: this.form.priority,
                repeatSpec: this.form.repeatSpec,
                validateFromWhen: this.form.validateFromWhen,
                validateToWhen: this.form.validateToWhen,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    /**
     * 修改跑马灯任务
     */
    updateMarquee() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let priority = parseInt(this.form.priority);
        if (priority.toString() != this.form.priority || priority < 0) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateMarqueeSchedule`,
            {
              entry: {
                id: this.value.oldData.id,
                text: this.form.text,
                priority: this.form.priority,
                repeatSpec: this.form.repeatSpec,
                validateFromWhen: this.form.validateFromWhen,
                validateToWhen: this.form.validateToWhen,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>